import React from 'react';
import { Stack, IconButton, Button, Box } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Radius } from 'lucide-react';
import TableEmptyRow from '../shared/TableEmptyRow';

const ReportDataTable = ({ filteredReports, loading, page, setPage, pageSize, totalCount, handleEnableChange }) => {
  const navigate = useNavigate();
  const totalPages = Math.ceil(totalCount / pageSize);

  const renderPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else if (page <= 3) {
      pages.push(1, 2, 3, '...', totalPages);
    } else if (page >= totalPages - 2) {
      pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
    }
    return pages;
  };

  // if (loading) return <div className="col-12 text-center text-muted py-5">Loading...</div>;

  {
    loading && (
      <div className="pd-table-loading">
        <div className="pd-table-loading-animation">
          <img
            className="pd-table-loading-video"
            src="/images/breath1.gif"
            alt="Loading reports..."
          />
          <p>Loading reports...</p>
        </div>
      </div>
    )
  }



  return (
    <>
      {
        loading ? (
          <div className="pd-table-loading">
            <div className="pd-table-loading-animation">
              <img
                className="pd-table-loading-video"
                src="/images/breath1.gif"
                alt="Loading reports..."
              />
              <p>Loading reports...</p>
            </div>
          </div>
        ) : (
          <>
            <div className={filteredReports.length === 0 ? "" : "d-none d-md-block"} style={{ overflowX: "auto", scrollbarWidth: "thin", minHeight: "200px", maxHeight: '400px', borderRadius: '6px' }}>
              <table
                className="pd-table"
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead>
                  <tr>
                    <th width="200px">Title</th>
                    {/* <th width="100px">Difficulty</th> */}
                    <th width="100px">Assessment Type</th>
                    {/* <th width="100px">Enrolled</th> */}
                    <th width="100px">Pass Percentage</th>
                    <th width="100px">Enable</th>
                    <th width="150px">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredReports.length === 0 ? (
                    <TableEmptyRow colSpan={5} message="No reports found" />
                  ) : filteredReports.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.title}</td>
                      {/* <td>{row.difficulty}</td> */}
                      <td>{row.exam_type}</td>
                      {/* <td>{row.enrolled}</td> */}
                      {/* <td>{row.pass_percent}%</td> */}
                      <td>
                        {row.pass_percent != null
                          ? `${Number(row.pass_percent).toFixed(2)}%`
                          : "—"}
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          checked={row.isenable === 1}
                          onChange={(e) =>
                            handleEnableChange(row.exam_id, e.target.checked)
                          }
                        />
                      </td>
                      <td
                        style={{
                          verticalAlign: 'middle',
                          textAlign: 'left',
                          paddingLeft: '8px',
                        }}
                      >
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="center"
                          justifyContent="flex-start"
                        >
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => navigate(`/report/users?examId=${row.exam_id}&examType=${row.exam_type}&examTitle=${encodeURIComponent(row.title)}&coursePage=${page}`)}

                          >
                            <ArrowForward fontSize="small" />
                          </IconButton>
                        </Stack>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className={filteredReports.length === 0 ? "d-none" : "d-md-none pr-1"} style={{ overflowX: "auto", scrollbarWidth: "thin", minHeight: "200px", maxHeight: '400px' }}>
              {filteredReports.map((row, i) => (
                <div key={i} className="card mb-3 glass-card border-0">
                  <div className="card-body">
                    <h5 className="card-title d-flex justify-content-between">
                      {row.title}
                      <IconButton size="small" color="primary" onClick={() => navigate(`/report/users?examId=${row.exam_id}`)}>
                        <ArrowForward fontSize="small" />
                      </IconButton>
                    </h5>
                    <p className="mb-1"><strong>Difficulty:</strong> {row.difficulty}</p>
                    <p className="mb-1"><strong>Assessment Type:</strong> {row.exam_type}</p>
                    <p className="mb-1"><strong>Scheduled:</strong> {row.scheduled}</p>
                    <p className="mb-1"><strong>Assigned:</strong> {row.assigned}</p>
                    <p className="mb-1"><strong>Enrolled:</strong> {row.enrolled}</p>
                    <p className="mb-0"><strong>Pass %:</strong> {row.pass_percent}%</p>
                  </div>
                </div>
              ))}
            </div>
            {filteredReports.length > 0 && <Box className="pd-pagination">

              {/* Previous */}
              <button
                className="btn-negative"
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                Previous
              </button>

              {/* Page Numbers */}
              <div className="pd-page-numbers">
                {renderPageNumbers().map((pageNum, index) => (
                  <button
                    key={index}
                    disabled={pageNum === "..."}
                    onClick={() =>
                      typeof pageNum === "number" && setPage(pageNum)
                    }
                    className={`pg-type-btn ${pageNum === page ? "active" : ""}`}
                  >
                    {pageNum}
                  </button>
                ))}
              </div>

              {/* Next */}
              <button
                className="btn-negative"
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Next
              </button>

            </Box>}

          </>
        )}
    </>
  );
};

export default ReportDataTable;
